/**
 * Validates that a blob response is a plausible PDF before download.
 * @param {Blob} blob
 * @param {number} minBytes
 * @returns {Promise<boolean>}
 */
async function readBlobPrefix(blob, length = 5) {
  const slice = blob.slice(0, length)
  if (typeof slice.arrayBuffer === 'function') {
    const buffer = await slice.arrayBuffer()
    return String.fromCharCode(...new Uint8Array(buffer))
  }
  if (typeof slice.text === 'function') {
    return (await slice.text()).slice(0, length)
  }
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () => {
      const arr = new Uint8Array(reader.result)
      resolve(String.fromCharCode(...arr))
    }
    reader.onerror = () => reject(reader.error)
    reader.readAsArrayBuffer(slice)
  })
}

export async function validatePdfBlob(blob, minBytes = 100) {
  if (!blob || blob.size < minBytes) return false

  const type = (blob.type || '').toLowerCase()
  if (type && !type.includes('pdf') && !type.includes('octet-stream')) return false

  const header = await readBlobPrefix(blob, 5)
  return header.startsWith('%PDF')
}

export default { validatePdfBlob }
